const computeMonthlyOn = on => ({
  bymonthday: on.day,
});

export default computeMonthlyOn;
